<template>
  <div class="inner-container" :class="{ 'min-container': !getTabs }">
    <div class="page-header">
      <h1>{{ $t("EDIT") }} {{ $t("CEE") }}</h1>
      <b-button
        size="sm"
        variant="danger"
        class="button-danger-style ml-2 float-right mb-2"
        @click="goBack"
      >
        <font-awesome-icon icon="arrow-left" /> {{"Retour" }}
      </b-button>
    </div>
    <div class="content">
      <b-card>
        <form @submit.prevent="handleSubmit">
          <!-- Entreprise selection for super-admin -->
          <b-form-group
            v-if="isSuperAdmin"
            :label="$t('ENTREPRISES')"
          >
            <multiselect
              v-model="selectedEntreprise"
              :searchable="true"
              :close-on-select="true"
              :multiple="false"
              :options="getAllentreprises"
              label="lib"
              track-by="id"
              :placeholder="$t('Select company')"
              class="form-input custom-placeholder custom-input"
              @input="updateSelectedEntreprise"
            >
              <template slot="noResult">
                {{ $t("NO_DATA_FOUND") }}
              </template>
            </multiselect>
          </b-form-group>

          <b-form-group :label="$t('CUSTOMER')">
            <div class="d-flex align-items-center">
              <multiselect
                v-model="selectedClient"
                :searchable="true"
                :close-on-select="true"
                :multiple="false"
                :options="getAllclients"
                :custom-label="customLabel"
                label="nom"
                track-by="id"
                :placeholder="$t('CUSTOMER')"
                class="form-input custom-placeholder custom-input"
                style="width: 100%; flex: 1;"
                @input="updateSelectedClient"
              />
              <button
                class="py-0 newstore rounded ml-2"
                @click="openModal('client')"
                id="buttonclient-with-popover"
                type="button"
              >
                +
              </button>
              <b-popover
                target="buttonclient-with-popover"
                placement="top"
                triggers="hover focus"
              >
                {{ $t("Ajouter un nouveau client") }}
              </b-popover>
              <clientmodale @updateList="loadClients" />
            </div>
          </b-form-group>

          <!-- Display and modification of selected client data -->
          <div v-if="selectedClient" class="client-info mt-3 mb-3 p-3" style="background-color: #f5f5f5; border-radius: 5px;">
            <h6>{{ $t("Information de client") }}</h6>
            <div class="row">
              <div class="col-md-6">
                <b-form-group :label="$t(' Nom et prenom')">
                  <b-form-input
                    v-if="selectedClient.type === 'type.professionnel'"
                    v-model="editableClientData.company"
                    :placeholder="$t('Nom')"
                    @blur="updateClientData"
                  />
                  <div v-else>
                    <b-form-input
                      v-model="editableClientData.prenom"
                      :placeholder="$t('Prenom')"
                      class="mb-2"
                      @blur="updateClientData"
                    />
                    <b-form-input
                      v-model="editableClientData.nom"
                      :placeholder="$t('Nom')"
                      @blur="updateClientData"
                    />
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group :label="$t('Email')">
                  <b-form-input
                    v-if="selectedClient.type === 'type.professionnel'"
                    v-model="editableClientData.company_email"
                    type="email"
                    :placeholder="$t('Email')"
                    @blur="updateClientData"
                  />
                  <b-form-input
                    v-else
                    v-model="editableClientData.email"
                    type="email"
                    :placeholder="$t('Email')"
                    @blur="updateClientData"
                  />
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group :label="$t('Phone')">
                  <phone
                    :tel="editableClientData.tel"
                    @phoneNumber="formatNumber($event)"
                  />
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group :label="$t('SIRET')">
                  <b-form-input
                    v-model="editableClientData.siret"
                    :placeholder="$t('SIRET')"
                    @blur="updateClientData"
                  />
                </b-form-group>
              </div>
              <div class="col-md-12">
                <b-form-group :label="$t('Rue')">
                  <b-form-input
                    v-model="editableClientData.rue"
                    :placeholder="$t('Street')"
                    class="mb-2"
                    @blur="updateClientData"
                  />
                  <div class="row">
                    <div class="col-md-4">
                      <b-form-input
                        v-model="editableClientData.cp"
                        :placeholder="$t('Postal Code')"
                        class="mb-2"
                        @blur="updateClientData"
                      />
                    </div>
                    <div class="col-md-8">
                      <b-form-input
                        v-model="editableClientData.ville"
                        :placeholder="$t('City')"
                        @blur="updateClientData"
                      />
                    </div>
                  </div>
                </b-form-group>
              </div>
            </div>
          </div>

          <b-form-group :label="$t('Type de travail')">
            <b-form-select
              v-model="formData.typeTravaux"
              :options="typeTravauxOptions"
              :placeholder="$t('Choisissez un type de travail')"
            >
              <template #first>
                <b-form-select-option :value="null" disabled>
                  {{ $t("Choisissez un type de travail") }}
                </b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>

          <b-form-group :label="$t('DELEGATAIRE')">
            <div class="d-flex align-items-center">
              <multiselect
                v-model="selectedDeligataire"
                :searchable="true"
                :close-on-select="true"
                :multiple="false"
                :options="getMondataireEntitesExternes"
                label="nom"
                track-by="id"
                :placeholder="$t('Select_agent') + '/' + $t('DELEGATAIRE')"
                class="form-input custom-placeholder custom-input flex-grow-1"
                @input="updateSelectedDeligataire"
              >
                <template slot="noResult">
                  {{ $t("NO_DATA_FOUND") }}
                </template>
              </multiselect>
              <button
                id="add-delegataire-popover-edit"
                class="mb-1 py-0 newstore rounded ml-2"
                @click.prevent="openDelegataireModal('add')"
                type="button"
              >
                +
              </button>
              <b-popover
                target="add-delegataire-popover-edit"
                placement="top"
                triggers="hover focus"
              >
                {{ $t("You can add a new Agent/Delegate") }}
              </b-popover>
            </div>
          </b-form-group>
          <mandataireEtpartenairemodale
            v-if="isDelegataireModalOpen"
            :isOpen="isDelegataireModalOpen"
            :updateEntrepriseId="formData.entreprise_id"
            @close="closeDelegataireModal"
            @confirm="handleDelegataireConfirm"
            :updateData="update_EntiteExterne"
          ></mandataireEtpartenairemodale>

          <!-- Champs signataire et poste du signataire -->
          <div v-if="selectedDeligataire" class="mt-3">
            <b-form-group :label="$t('Signataire') || 'Signataire'">
              <b-form-input
                v-model="formData.signataire"
                :placeholder="$t('Signataire') || 'Signataire'"
                class="form-input"
              />
            </b-form-group>
            
            <b-form-group :label="$t('Poste du signataire') || 'Poste du signataire'">
              <b-form-input
                v-model="formData.poste_signataire"
                :placeholder="$t('Poste du signataire') || 'Poste du signataire'"
                class="form-input"
              />
            </b-form-group>
          </div>

          <hr />

        
          
          <div class="prime-options">
            <div class="row">
              <!-- Column 1 - Row 1 -->
              <div class="col-md-6 mb-3">
                <b-form-group class="prime-option-item h-100">
                  <b-form-checkbox
                    v-model="formData.engagement"
                    value="prime"
                    @change="handleTypeToggle('prime')"
                    class="prime-checkbox"
                  >
                    Prime
                  </b-form-checkbox>
                  <div v-if="formData.engagement.includes('prime')" class="mt-2 ml-4">
                    <b-form-group label="Montant en euros">
                      <b-form-input
                        v-model.number="formData.amount_grant"
                        type="number"
                        step="0.01"
                        min="0"
                        placeholder="Montant en euros"
                        style="width: 100%;"
                      />
                    </b-form-group>
                  </div>
                </b-form-group>
              </div>

              <!-- Column 2 - Row 1 -->
              <div class="col-md-6 mb-3">
                <b-form-group class="prime-option-item h-100">
                  <b-form-checkbox
                    v-model="formData.engagement"
                    value="bon_achat"
                    @change="handleTypeToggle('bon_achat')"
                    class="prime-checkbox"
                  >
Un bon d'achat pour des produits de consommation courant                  </b-form-checkbox>
                  <div v-if="formData.engagement.includes('bon_achat')" class="mt-2 ml-4">
                    <b-form-group label="Montant en euros">
                      <b-form-input
                        v-model.number="formData.amount_voucher"
                        type="number"
                        step="0.01"
                        min="0"
                        placeholder="Montant en euros"
                        style="width: 100%;"
                      />
                    </b-form-group>
                  </div>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <!-- Column 1 - Row 2 -->
              <div class="col-md-6 mb-3">
                <b-form-group class="prime-option-item h-100">
                  <b-form-checkbox
                    v-model="formData.engagement"
                    value="pret_bonifie"
                    @change="handleTypeToggle('pret_bonifie')"
                    class="prime-checkbox"
                  >
                    Un prêt bonifié
                  </b-form-checkbox>
                  <div v-if="formData.engagement.includes('pret_bonifie')" class="mt-2 ml-4">
                    <b-form-group label="Montant">
                      <b-form-input
                        v-model.number="formData.loan_amount"
                        type="number"
                        step="0.01"
                        min="0"
                        placeholder="Montant en euros"
                        style="width: 100%;"
                      />
                    </b-form-group>
                    <b-form-group label="Proposé par">
                      <b-form-input
                        v-model="formData.loan_organization"
                        placeholder="Proposé"
                        style="width: 100%;"
                      />
                    </b-form-group>
                    <b-form-group label="Taux Effectif Global (TEG)">
                      <b-form-input
                        v-model.number="formData.egr_rate"
                        type="number"
                        step="0.01"
                        min="0"
                        max="100"
                        placeholder="%"
                        style="width: 100%;"
                      />
                    </b-form-group>
                    <b-form-group label="Value de bonification">
                      <b-form-input
                        v-model.number="formData.subsidy_value"
                        type="number"
                        step="0.01"
                        min="0"
                        placeholder="Value"
                        style="width: 100%;"
                      />
                    </b-form-group>
                  </div>
                </b-form-group>
              </div>

              <!-- Column 2 - Row 2 -->
              <div class="col-md-6 mb-3">
                <b-form-group class="prime-option-item h-100">
                  <b-form-checkbox
                    v-model="formData.engagement"
                    value="audit"
                    @change="handleTypeToggle('audit')"
                    class="prime-checkbox"
                  >
Un audit ou conseil personnalisé                  </b-form-checkbox>
                  <div v-if="formData.engagement.includes('audit')" class="mt-2 ml-4">
                    <b-form-group label="Valeur en euros">
                      <b-form-input
                        v-model.number="formData.audit_value"
                        type="number"
                        step="0.01"
                        min="0"
                        placeholder="Valeur en euros"
                        style="width: 100%;"
                      />
                    </b-form-group>
                  </div>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <!-- Column 1 - Row 3 (full width) -->
              <div class="col-md-6 mb-3">
                <b-form-group class="prime-option-item h-100">
                  <b-form-checkbox
                    v-model="formData.engagement"
                    value="produit_service"
                    @change="handleTypeToggle('produit_service')"
                    class="prime-checkbox"
                  >
                                        Un produit ou service

                  </b-form-checkbox>
                  <div v-if="formData.engagement.includes('produit_service')" class="mt-2 ml-4">
                    <b-form-group label="Proposé">
                      <b-form-input
                        v-model="formData.product_service_description"
                        placeholder="Description du produit ou du service proposé"
                        style="width: 100%;"
                      />
                    </b-form-group>
                    <b-form-group label="Value">
                      <b-form-input
                        v-model.number="formData.product_service_value"
                        type="number"
                        step="0.01"
                        min="0"
                        placeholder="Valuer en euros"
                        style="width: 100%;"
                      />
                    </b-form-group>
                  </div>
                </b-form-group>
              </div>
            </div>
          </div>

          <hr />

          <b-form-group :label="$t('Où se rensenseigner pour bénéficier de cette offre ?')">
            <b-form-input
              v-model="formData.information_link"
              type="url"
              placeholder="https://example.com"
              class="form-input"
            />
           
          </b-form-group>

          <div class="form-actions">
            <b-button variant="danger" @click="goBack" class="mr-2">
              {{ $t("CANCEL") }}
            </b-button>
            <b-button
              variant="success"
              type="submit"
              :disabled="getCEELoading"
            >
              {{ $t("SAVE") }}
              <b-spinner
                v-if="getCEELoading"
                small
                variant="light"
                class="ml-2"
              ></b-spinner>
            </b-button>
          </div>
        </form>
      </b-card>
    </div>

    <div class="text-center center-spin">
      <b-spinner
        v-if="isLoading"
        variant="primary"
        label="Spinning"
        class="big-spin"
      ></b-spinner>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import clientmodale from "@/components/Ajoutmodel/clientmodale.vue";
import phone from "@/components/ui/phone.vue";
import mandataireEtpartenairemodale from "@/components/Ajoutmodel/mandataireEtpartenairemodale.vue";

export default {
  components: {
    clientmodale,
    phone,
    mandataireEtpartenairemodale,
  },
  setup() {
    return { v$: useVuelidate({ $lazy: true, $autoDirty: true }) };
  },
  data() {
    return {
      isLoading: true,
      selectedClient: null,
      editableClientData: {},
      selectedEntreprise: null,
      selectedDeligataire: null,
      isDelegataireModalOpen: false,
      update_EntiteExterne: null,
      formData: {
        clientId: null,
        entreprise_id: null,
        deligater_id: null,
        typeTravaux: null,
        engagement: [],
        amount_grant: null,
        amount_voucher: null,
        loan_amount: null,
        loan_organization: null,
        egr_rate: null,
        subsidy_value: null,
        audit_value: null,
        product_service_description: null,
        product_service_value: null,
        information_link: null,
        signataire: null,
        poste_signataire: null,
      },
      typeTravauxOptions: [
        { value: "BAR-EN-101", text: "BAR-EN-101" },
        { value: "BAR-EN-102", text: "BAR-EN-102" },
        { value: "BAR-EN-103", text: "BAR-EN-103" },
        { value: "BAR-EN-104", text: "BAR-EN-104" },
        { value: "BAR-TH-112", text: "BAR-TH-112" },
        { value: "BAR-TH-127", text: "BAR-TH-127" },
        { value: "BAR-TH-129", text: "BAR-TH-129" },
        { value: "BAR-TH-148", text: "BAR-TH-148" },
        { value: "BAR-TH-161", text: "BAR-TH-161 Isolation de points singuliers d'un réseau" },
        { value: "BAR-TH-171", text: "BAR-TH-171" },
        { value: "BAT-TH-142", text: "BAT-TH-142" },
        { value: "renovation d'ampleur", text: "renovation d'ampleur" },
      ],
    };
  },
  validations() {
    return {
      formData: {},
    };
  },
  methods: {
    ...mapActions(["getOneCEE", "updateCEE", "all_clients", "edit_client", "all_entreprises", "allEntitesExternes", "storeEntiteExterne", "editEntiteExterne", "client"]),
    initializeEditableClientData() {
      if (this.selectedClient) {
        // Initialize tel object for phone component (as in ClientStep.vue)
        let tel = null;
        if (this.selectedClient.phone) {
          tel = {
            phone_number: this.selectedClient.phone.phone_number || "",
            phone_iso_code: this.selectedClient.phone.iso_code || this.selectedClient.phone.phone_iso_code || "FR",
          };
        } else if (this.selectedClient.tel) {
          if (typeof this.selectedClient.tel === "object") {
            tel = {
              phone_number: this.selectedClient.tel.phone_number || "",
              phone_iso_code: this.selectedClient.tel.iso_code || this.selectedClient.tel.phone_iso_code || "FR",
            };
          } else {
            tel = {
              phone_number: this.selectedClient.tel || "",
              phone_iso_code: "FR",
            };
          }
        } else {
          tel = {
            phone_number: "",
            phone_iso_code: "FR",
          };
        }
        
        this.editableClientData = {
          id: this.selectedClient.id,
          nom: this.selectedClient.nom || "",
          prenom: this.selectedClient.prenom || "",
          company: this.selectedClient.company || "",
          email: this.selectedClient.email || "",
          company_email: this.selectedClient.company_email || "",
          tel: tel,
          siret: this.selectedClient.siret || "",
          rue: this.selectedClient.rue || "",
          cp: this.selectedClient.cp || "",
          ville: this.selectedClient.ville || "",
          type: this.selectedClient.type || "type.particulier",
        };
      }
    },
    formatNumber(event) {
      if (event && event.number && event.country) {
        if (!this.editableClientData.tel) {
          this.editableClientData.tel = {};
        }
        this.editableClientData.tel = {
          phone_number: event.number,
          phone_iso_code: event.country.iso2,
        };
      }
    },
    async updateClientData() {
      if (!this.selectedClient || !this.editableClientData.id) {
        return;
      }
      
      try {
        const clientData = {
          id: this.editableClientData.id,
          nom: this.editableClientData.nom,
          prenom: this.editableClientData.prenom,
          company: this.editableClientData.company,
          email: this.editableClientData.email || null,
          company_email: this.editableClientData.company_email || null,
          siret: this.editableClientData.siret,
          rue: this.editableClientData.rue,
          cp: this.editableClientData.cp,
          ville: this.editableClientData.ville,
          type: this.editableClientData.type,
        };
        
        // Add phone data if it exists
        if (this.editableClientData.tel && this.editableClientData.tel.phone_number) {
          // Clean the number by removing the prefix (which is displayed separately)
          let phoneNumber = this.editableClientData.tel.phone_number;
          const spaceIndex = phoneNumber.indexOf(" ");
          if (spaceIndex !== -1) {
            phoneNumber = phoneNumber.slice(spaceIndex + 1).split(" ").join("");
          }
          clientData.tel = {
            phone_number: phoneNumber,
            phone_iso_code: this.editableClientData.tel.phone_iso_code || "FR",
          };
        }
        
        await this.edit_client({ data: clientData });
        
        // Reload clients to update data
        await this.loadClients();
        
        // Update the selected client
        if (this.getAllclients && Array.isArray(this.getAllclients)) {
          const updatedClient = this.getAllclients.find(c => c.id === clientData.id);
          if (updatedClient) {
            this.selectedClient = updatedClient;
            this.initializeEditableClientData();
          }
        }
      } catch (error) {
        console.error("Error updating client:", error);
      }
    },
    customLabel(client) {
      if (client.type === "type.professionnel" && client.company) {
        return client.company;
      }
      return `${client.nom || ""} ${client.prenom || ""}`.trim() || client.full_name || "-";
    },
    openModal(type) {
      if (type === "client") {
        this.$root.$emit("bv::show::modal", "clientStoreModal");
      }
    },
    async loadClients() {
      try {
        const entrepriseId = this.isSuperAdmin 
          ? (this.selectedEntreprise ? this.selectedEntreprise.id : null)
          : (this.getOnlineUser && this.getOnlineUser.entreprise ? this.getOnlineUser.entreprise.id : null);
        
        await this.all_clients({
          page: 1,
          per_page: 10000,
          entreprise_id: entrepriseId,
        });
      } catch (error) {
        console.error("Error loading clients:", error);
      }
    },
    updateSelectedEntreprise(entreprise) {
      this.selectedEntreprise = entreprise;
      if (entreprise) {
        this.formData.entreprise_id = entreprise.id;
        // Reload clients for the selected enterprise
        this.loadClients();
        // Reload entites externes for the selected enterprise
        this.loadEntitesExternes();
        // Clear selected client when enterprise changes
        this.selectedClient = null;
        this.formData.clientId = null;
        this.editableClientData = {};
      } else {
        this.formData.entreprise_id = null;
      }
    },
    updateSelectedDeligataire(deligataire) {
      this.selectedDeligataire = deligataire;
      if (deligataire) {
        this.formData.deligater_id = deligataire.id;
      } else {
        this.formData.deligater_id = null;
        // Réinitialiser les champs signataire si on désélectionne
        this.formData.signataire = null;
        this.formData.poste_signataire = null;
      }
    },
    async loadEntitesExternes() {
      try {
        let entrepriseId = null;
        
        if (this.isSuperAdmin) {
          // For super-admin, try selectedEntreprise first, then formData.entreprise_id
          entrepriseId = this.selectedEntreprise 
            ? this.selectedEntreprise.id 
            : (this.formData.entreprise_id || null);
        } else {
          // For non-super-admin, try formData.entreprise_id first, then connected user's entreprise
          entrepriseId = this.formData.entreprise_id 
            || (this.getOnlineUser && this.getOnlineUser.entreprise ? this.getOnlineUser.entreprise.id : null);
        }
        
        if (!entrepriseId) {
          console.warn("Cannot load entites externes: no entreprise_id available");
          return;
        }
        
        await this.allEntitesExternes({
          page: 1,
          per_page: 10000,
          entreprise_id: entrepriseId,
        });
      } catch (error) {
        console.error("Error loading entites externes:", error);
      }
    },
    openDelegataireModal(action, updateData = null) {
      this.update_EntiteExterne = updateData;
      this.isDelegataireModalOpen = true;
    },
    closeDelegataireModal() {
      this.isDelegataireModalOpen = false;
      this.update_EntiteExterne = null;
    },
    async handleDelegataireConfirm(EntiteExtData) {
      try {
        if (!EntiteExtData) {
          this.closeDelegataireModal();
          return;
        }

        // Check if it's a creation or update
        if (this.update_EntiteExterne) {
          // Update existing entite externe
          const update = {
            ...EntiteExtData,
            id: this.update_EntiteExterne.id,
          };
          
          // Handle logo with FormData if present
          let payload = update;
          if (EntiteExtData.logo && EntiteExtData.logo instanceof File) {
            const bodyFormData = new FormData();
            Object.keys(update).forEach(key => {
              if (key === 'logo') {
                bodyFormData.append('logo', update.logo);
              } else if (update[key] !== null && update[key] !== undefined) {
                bodyFormData.append(key, String(update[key]));
              }
            });
            payload = bodyFormData;
          }
          
          const response = await this.editEntiteExterne(payload);
          if (response && response.id) {
            await this.loadEntitesExternes();
            const updatedDelegataire = this.getMondataireEntitesExternes?.find(
              (d) => d.id === response.id && (d.type === 'mandataire' || d.type === 'delegataire')
            );
            if (updatedDelegataire) {
              this.updateSelectedDeligataire(updatedDelegataire);
            }
          }
        } else {
          // Create new entite externe
          // Ensure type is delegataire or mandataire
          if (EntiteExtData.type === "delegataire" || EntiteExtData.type === "mandataire") {
            // Handle logo with FormData if present
            let payload = EntiteExtData;
            if (EntiteExtData.logo && EntiteExtData.logo instanceof File) {
              const bodyFormData = new FormData();
              Object.keys(EntiteExtData).forEach(key => {
                if (key === 'logo') {
                  bodyFormData.append('logo', EntiteExtData.logo);
                } else if (EntiteExtData[key] !== null && EntiteExtData[key] !== undefined) {
                  bodyFormData.append(key, EntiteExtData[key]);
                }
              });
              payload = bodyFormData;
            }
            
            const createdEntity = await this.storeEntiteExterne(payload);
            
            // Reload entites externes to get the newly created one
            await this.loadEntitesExternes();
            
            // Wait a bit for the store to update
            await this.$nextTick();
            
            // Find and select the newly created delegataire
            if (createdEntity && createdEntity.id) {
              const newDelegataire = this.getMondataireEntitesExternes?.find(
                (d) => d.id === createdEntity.id && (d.type === 'mandataire' || d.type === 'delegataire')
              );
              if (newDelegataire) {
                this.updateSelectedDeligataire(newDelegataire);
              }
            } else if (this.getMondataireEntitesExternes && Array.isArray(this.getMondataireEntitesExternes)) {
              // Fallback: search by name and type
              const newDelegataire = this.getMondataireEntitesExternes.find(
                (d) => d.nom === EntiteExtData.nom && 
                       (d.type === 'mandataire' || d.type === 'delegataire')
              );
              if (newDelegataire) {
                this.updateSelectedDeligataire(newDelegataire);
              }
            }
          }
        }
      } catch (error) {
        console.error("Error handling delegataire creation:", error);
        alert(error?.response?.data?.message || error?.message || "An error occurred while saving the delegataire.");
      } finally {
        this.closeDelegataireModal();
      }
    },
    updateSelectedClient(client) {
      this.selectedClient = client;
      if (client) {
        this.formData.clientId = client.id;
        this.initializeEditableClientData();
      } else {
        this.formData.clientId = null;
        this.editableClientData = {};
      }
    },
    // Static work types list - no need to load from API
    loadTypeTravaux() {
      // Options are already initialized in data() as static list
      // This method is kept for consistency but does nothing
    },
    validateState(name) {
      const { $dirty, $error } = this.v$.formData[name];
      return $dirty ? !$error : null;
    },
    goBack() {
      this.$router.push("/gestion-dossiers");
    },
    handleTypeToggle(type) {
      // Use $nextTick to ensure the engagement array is updated after the checkbox change
      this.$nextTick(() => {
        // Reset specific fields for this type when it is deselected
        if (!this.formData.engagement.includes(type)) {
          if (type === "prime") {
            this.formData.amount_grant = null;
          } else if (type === "bon_achat") {
            this.formData.amount_voucher = null;
          } else if (type === "pret_bonifie") {
            this.formData.loan_amount = null;
            this.formData.loan_organization = null;
            this.formData.egr_rate = null;
            this.formData.subsidy_value = null;
          } else if (type === "audit") {
            this.formData.audit_value = null;
          } else if (type === "produit_service") {
            this.formData.product_service_description = null;
            this.formData.product_service_value = null;
          }
        }
      });
    },
    async loadCEE() {
      if (this.$route.params.id) {
        try {
          const response = await this.getOneCEE(this.$route.params.id);
          if (response && response.data) {
            const cee = response.data;
            this.formData.clientId = cee.client_id;
            this.formData.entreprise_id = cee.entreprise_id;
            
            // Initialize entreprise selection
            if (this.isSuperAdmin && cee.entreprise_id) {
              // Load enterprises if super-admin
              await this.all_entreprises({
                page: 1,
                per_page: 1000,
              });
              // Find and set selected entreprise
              if (this.getAllentreprises && Array.isArray(this.getAllentreprises)) {
                this.selectedEntreprise = this.getAllentreprises.find(e => e.id === cee.entreprise_id) || null;
              }
            }
            
            // Load clients after entreprise is set
            await this.loadClients();
            
            // Wait for the store to update with the loaded clients
            await this.$nextTick();
            
            // Load selected client after loading clients
            if (cee.client_id) {
              // First, try to use the client object from the CEE response if available
              if (cee.client && cee.client.id) {
                this.selectedClient = cee.client;
                this.initializeEditableClientData();
              } else if (this.getAllclients && Array.isArray(this.getAllclients)) {
                // Try to find the client in the loaded list
                const foundClient = this.getAllclients.find(c => {
                  const cId = Number(c.id);
                  const searchId = Number(cee.client_id);
                  return cId === searchId || c.id == cee.client_id || String(c.id) === String(cee.client_id);
                });
                
                if (foundClient) {
                  this.selectedClient = foundClient;
                  this.initializeEditableClientData();
                } else {
                  // If client not found in filtered list, try loading without filter or load the specific client
                  console.warn("Client not found in filtered list. Client ID:", cee.client_id);
                  console.warn("Available clients:", this.getAllclients.map(c => ({ id: c.id, nom: c.nom, prenom: c.prenom })));
                  
                  // Try to load the specific client directly
                  try {
                    const clientResponse = await this.client(cee.client_id);
                    if (clientResponse && clientResponse.data) {
                      this.selectedClient = clientResponse.data;
                      this.initializeEditableClientData();
                    }
                  } catch (error) {
                    console.error("Error loading specific client:", error);
                  }
                }
              }
            }
            
            // Load entites externes after entreprise is set
            await this.loadEntitesExternes();
            
            // Load type travaux after entreprise is set (before setting the value)
            this.loadTypeTravaux();
            
            // Load deligataire after entites externes are loaded
            const delegataireId = cee.deligater_id || cee.delegataire_id || null;
            this.formData.deligater_id = delegataireId;
            
            if (delegataireId) {
              // Wait a bit to ensure entites externes are fully loaded and filtered
              await this.$nextTick();
              
              // First try to use the delegataire object if it's already loaded in the response
              if (cee.delegataire && cee.delegataire.id) {
                this.selectedDeligataire = cee.delegataire;
              } else if (this.getMondataireEntitesExternes && Array.isArray(this.getMondataireEntitesExternes) && this.getMondataireEntitesExternes.length > 0) {
                // Try to find by ID with multiple comparison methods
                this.selectedDeligataire = this.getMondataireEntitesExternes.find(
                  d => {
                    const dId = Number(d.id);
                    const searchId = Number(delegataireId);
                    return dId === searchId || d.id == delegataireId || String(d.id) === String(delegataireId);
                  }
                ) || null;
                
                if (!this.selectedDeligataire) {
                  console.warn("Delegataire not found in filtered list. Searching ID:", delegataireId);
                  console.warn("Available delegataires:", this.getMondataireEntitesExternes.map(d => ({ id: d.id, nom: d.nom })));
                }
              } else {
                console.warn("No delegataires loaded or list is empty");
              }
            }
            
            // Set typeTravaux after options are loaded to ensure it displays correctly
            if (cee.type_travaux) {
              // Use nextTick to ensure the select component has updated with the new options
              await this.$nextTick();
              this.formData.typeTravaux = cee.type_travaux;
            }
            
            // Rebuild engagement from data
            this.formData.engagement = [];
            if (cee.type_prime) {
              // If type_prime is an array, use it directly
              if (Array.isArray(cee.type_prime)) {
                this.formData.engagement = cee.type_prime;
              } else {
                // Otherwise, it's a single type
                this.formData.engagement = [cee.type_prime];
              }
            }
            
            this.formData.amount_grant = cee.montant_prime;
            this.formData.amount_voucher = cee.montant_bon_achat;
            this.formData.loan_amount = cee.montant_pret;
            this.formData.loan_organization = cee.organisme_pret;
            this.formData.egr_rate = cee.taux_teg;
            this.formData.subsidy_value = cee.valeur_bonification;
            this.formData.audit_value = cee.valeur_audit;
            this.formData.product_service_description = cee.description_produit_service;
            this.formData.product_service_value = cee.valeur_produit_service;
            this.formData.information_link = cee.lien_renseignement;
            this.formData.signataire = cee.signataire || null;
            this.formData.poste_signataire = cee.poste_signataire || null;
          }
        } catch (error) {
          console.error("Error loading CEE:", error);
        } finally {
          this.isLoading = false;
        }
      } else {
        // If no ID provided, disable loading immediately
        this.isLoading = false;
      }
    },
    async handleSubmit() {
      try {
        const payload = {
          id: this.$route.params.id,
          client_id: this.formData.clientId,
          entreprise_id: this.formData.entreprise_id,
          deligater_id: this.formData.deligater_id,
          type_travaux: this.formData.typeTravaux,
          type_prime: this.formData.engagement && this.formData.engagement.length > 0 ? this.formData.engagement : null,
        };

        // Add fields according to selected types - always send all fields, null if type is not selected
        if (this.formData.engagement && this.formData.engagement.includes("prime")) {
          payload.montant_prime = this.formData.amount_grant || null;
        } else {
          payload.montant_prime = null;
        }
        
        if (this.formData.engagement && this.formData.engagement.includes("bon_achat")) {
          payload.montant_bon_achat = this.formData.amount_voucher || null;
        } else {
          payload.montant_bon_achat = null;
        }
        
        if (this.formData.engagement && this.formData.engagement.includes("pret_bonifie")) {
          payload.montant_pret = this.formData.loan_amount || null;
          payload.organisme_pret = this.formData.loan_organization || null;
          payload.taux_teg = this.formData.egr_rate || null;
          payload.valeur_bonification = this.formData.subsidy_value || null;
        } else {
          payload.montant_pret = null;
          payload.organisme_pret = null;
          payload.taux_teg = null;
          payload.valeur_bonification = null;
        }
        
        if (this.formData.engagement && this.formData.engagement.includes("audit")) {
          payload.valeur_audit = this.formData.audit_value || null;
        } else {
          payload.valeur_audit = null;
        }
        
        if (this.formData.engagement && this.formData.engagement.includes("produit_service")) {
          payload.description_produit_service = this.formData.product_service_description || null;
          payload.valeur_produit_service = this.formData.product_service_value || null;
        } else {
          payload.description_produit_service = null;
          payload.valeur_produit_service = null;
        }

        // Add the information link
        if (this.formData.information_link) {
          payload.lien_renseignement = this.formData.information_link;
        }

        // Add signataire fields
        payload.signataire = this.formData.signataire || null;
        payload.poste_signataire = this.formData.poste_signataire || null;

        await this.updateCEE(payload);
        this.$router.push("/gestion-dossiers");
      } catch (error) {
        console.error("Error updating CEE:", error);
        alert(error?.response?.data?.message || error?.message || "An error occurred while saving.");
      }
    },
  },
  computed: {
    ...mapGetters([
      "getTabs",
      "getOnlineUser",
      "getCEELoading",
      "getAllclients",
      "getAllentreprises",
      "getMondataireEntitesExternes",
    ]),
    isSuperAdmin() {
      return this.getOnlineUser && this.getOnlineUser.role == "user.super-admin";
    },
    getClientFullName() {
      if (!this.selectedClient) return "-";
      if (this.selectedClient.type === "type.professionnel" && this.selectedClient.company) {
        return this.selectedClient.company;
      }
      return `${this.selectedClient.nom || ""} ${this.selectedClient.prenom || ""}`.trim() || this.selectedClient.full_name || "-";
    },
    getClientPhone() {
      if (!this.selectedClient) return "-";
      if (this.selectedClient.phone && this.selectedClient.phone.formated_phone) {
        return this.selectedClient.phone.formated_phone;
      }
      if (this.selectedClient.phone && this.selectedClient.phone.phone_number) {
        return this.selectedClient.phone.phone_number;
      }
      if (this.selectedClient.tel) {
        return this.selectedClient.tel;
      }
      return "-";
    },
    getClientAddress() {
      if (!this.selectedClient) return "-";
      const parts = [];
      if (this.selectedClient.rue) parts.push(this.selectedClient.rue);
      if (this.selectedClient.cp) parts.push(this.selectedClient.cp);
      if (this.selectedClient.ville) parts.push(this.selectedClient.ville);
      return parts.length > 0 ? parts.join(", ") : "-";
    },
  },
  async mounted() {
    // Set loading to true immediately when component is mounted to avoid delay
    this.isLoading = true;
    
    // Load enterprises for super-admin
    if (this.isSuperAdmin) {
      await this.all_entreprises({
        page: 1,
        per_page: 1000,
      });
    } else {
      // For non-super-admin, initialize entreprise_id from connected user
      if (this.getOnlineUser && this.getOnlineUser.entreprise) {
        this.formData.entreprise_id = this.getOnlineUser.entreprise.id;
      }
    }
    
    // Load CEE first - it will load all dependent data (clients, entites externes, type travaux)
    await this.loadCEE();
  },
};
</script>

<style lang="scss" scoped>
.content {
  margin-top: 20px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #dee2e6;
}

.button-danger-style {
  background-color: #dc3545;
  border-color: #dc3545;
  color: #fff;
}

.button-danger-style:hover {
  background-color: #c82333;
  border-color: #bd2130;
}

.prime-options {
  margin-top: 15px;
}

.prime-option-item {
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f8f9fa;
  transition: all 0.3s ease;
  height: 100%;
  min-height: 80px;
}

.prime-option-item:hover {
  border-color: #007bff;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1);
}

.prime-checkbox {
  line-height: 1.8;
  font-weight: 500;
}

.inline-input {
  vertical-align: middle;
}

.client-info {
  border: 1px solid #dee2e6;
}

.newstore {
  background-color: #34c38f;
  color: white;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.newstore:hover {
  background-color: #28a085;
}
</style>

